<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9987 6.66668L18.332 10M18.332 10L14.9987 13.3333M18.332 10L9.7487 10C9.30483 10.0048 8.86449 9.92083 8.4535 9.75312C8.04252 9.58541 7.66917 9.33729 7.35536 9.02334L1.66536 3.33334M1.66536 16.6667L5.83203 12.5"
      stroke="#1F2937"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
